export enum ArrayLocationAPIResponse {
  Rooftop = 'rooftop',
  Carport = 'carport',
  Parktop = 'parktop',
  Ground = 'ground',
  Storage = 'storage',
  RoofAndCarport = 'roofAndCarport',
  RoofAndParktop = 'roofAndParktop',
  CarportAndParktop = 'carportAndParktop',
  RoofAndCarportAndParktop = 'roofAndCarportAndParktop',
}
